import { NgModule } from '@angular/core';
import { ConfigOption, FormlyModule } from '@ngx-formly/core';

import { SharedModule } from 'ish-shared/shared.module';

import { CustomQuickorderAddProductsFormComponent } from './shared/custom-quickorder-add-products-form/custom-quickorder-add-products-form.component';
import { CustomQuickorderFlyoutComponent } from './shared/custom-quickorder-flyout/custom-quickorder-flyout.component';
import { CustomQuickorderOrderTemplateListComponent } from './shared/custom-quickorder-order-template-list/custom-quickorder-order-template-list.component';
import { CustomQuickorderUploadComponent } from './shared/custom-quickorder-upload/custom-quickorder-upload.component';
import { CustomQuickorderFlyoutFormComponent } from './shared/formly/custom-quickorder-flyout-form/custom-quickorder-flyout-form.component';
import { CustomQuickorderRepeatFieldComponent } from './shared/formly/custom-quickorder-repeat-field/custom-quickorder-repeat-field.component';
import { CustomQuickorderSearchFieldComponent } from './shared/formly/custom-quickorder-search-field/custom-quickorder-search-field.component';
import { ProductLoadingComponent } from './shared/product-loading/product-loading.component';
import { QuickOrderQuantityComponent } from './shared/quick-order-quantity/quick-order-quantity.component';

const quickOrderFormlyConfig: ConfigOption = {
  types: [
    {
      name: 'custom-repeat',
      component: CustomQuickorderRepeatFieldComponent,
    },
    {
      name: 'flyout',
      component: CustomQuickorderFlyoutFormComponent,
    },
    {
      name: 'quick-order-search-input-field',
      component: CustomQuickorderSearchFieldComponent,
      wrappers: ['form-field-horizontal', 'validation'],
    },
  ],
};

@NgModule({
  imports: [FormlyModule.forChild(quickOrderFormlyConfig), SharedModule],
  declarations: [
    CustomQuickorderAddProductsFormComponent,
    CustomQuickorderFlyoutComponent,
    CustomQuickorderFlyoutFormComponent,
    CustomQuickorderOrderTemplateListComponent,
    CustomQuickorderRepeatFieldComponent,
    CustomQuickorderSearchFieldComponent,
    CustomQuickorderUploadComponent,
    ProductLoadingComponent,
    QuickOrderQuantityComponent,
  ],
  exports: [
    CustomQuickorderAddProductsFormComponent,
    CustomQuickorderOrderTemplateListComponent,
    CustomQuickorderUploadComponent,
    SharedModule,
  ],
})
export class CustomQuickorderModule {}
